const UserPackageSource = {
    SOURCE_RECURLY : 'recurly',
    SOURCE_PSP : 'psp',
    SOURCE_CBSCOMP : 'cbscomp',
    SOURCE_APPLEITUNES : 'appleitunes',
    SOURCE_GOOGLEPLAY : 'googleplay',
    SOURCE_ROKU : 'roku',
    SOURCE_AMAZONAPPSTORE : 'amazonappstore',
    SOURCE_SHOWTIME : 'showtime',
    SOURCE_OPTIMUM : 'optimum',
    SOURCE_AMAZONPRIME : 'amazonprime',
    SOURCE_APPLE_PLUS : 'applechannels',
    SOURCE_SPORTSLINE : 'sportsline',
    SOURCE_SPORTS247 : '247sports',
    SOURCE_FETCH_TV : 'fetchoauth',
    SOURCE_PARTNER_SUBSCRIPTION : 'partnersubscription',
    SOURCE_TMOBILE : 'tmobile',
    SOURCE_COMCAST : 'comcast',
    SOURCE_WALMARTPLUS : 'walmartplus',
}

export {UserPackageSource};
